import { faFileXmark } from '@fortawesome/pro-light-svg-icons/faFileXmark';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import { THEME_CONSTANTS } from '../../../../../../../../../ui-components/services/button-theme-service';
import { messages } from '../messages';
import styles from '../style.module.less';

import type { MessageDescriptor } from 'react-intl';

type ErrorStateProps = {
  errorMessage: MessageDescriptor;
  errorMessageValues?: Record<string, string | number>;
  onReplaceFile: () => void;
};

export const ErrorState = ({ errorMessage, errorMessageValues, onReplaceFile }: ErrorStateProps) => {
  return (
    <div className={styles['drag-drop-content']}>
      <FontAwesomeIcon className={styles['error-icon']} icon={faFileXmark} />
      <Text
        className={styles['error-text']}
        formattedMessageValues={errorMessageValues}
        textType={TextType.Paragraph}
        value={errorMessage}
      />
      <Button className={styles['replace-file-button']} onClick={onReplaceFile} theme={THEME_CONSTANTS.primary}>
        <FormattedMessage {...messages.selectAFile} />
      </Button>
    </div>
  );
};
